import { Link } from "react-router-dom"
import { Calendar, ArrowRight } from "lucide-react"


const NewsSection = () => {
  const newsItems = [
    {
      id: 1,
      title: "Mamata Academy of Medical Sciences Hospital Recognized for Excellence in Patient Care",
      excerpt:
         "We're proud to announce that MAMS Hospitals has received the prestigious Healthcare Excellence Award for outstanding patient care and safety standards.",
      date: "May 2, 2025",
      // category: "Hospital News",
      image: "/6c4hYqFbAaw?si=9z3L_wkralbtnXE0",
      slug: "new-cardiac-care-unit",
    },
    {
      id: 2,
      title: "A Rare Surgery Performed at Mamata Academy of Medical Sciences Hospital",
      excerpt:
        "Mamata Academy of Medical Sciences Hospital has achieved another milestone by successfully performing a rare and complex surgery, showcasing the expertise and dedication of its medical team. ",
      date: "April 15, 2025",
      // category: "Awards",
      image: "/FJG3x3Luye4?si=UUxs3tXnYI7UVdoy",
      slug: "recognized-for-excellence-patient-care",
    },
    {
      id: 3,
      title: " Maternity Kit Distribution to New Mothers | Celebrating Aparna Puvvada Maam’s Birthday",
      excerpt:
       "On the occasion of Aparna Puvvada Ma’am’s birthday, this heartfelt event features the distribution of essential maternity kits to new mothers. The video captures touching moments of gratitude, supportive community spirit, and the joy of giving back. ",
      date: "April 5, 2025",
      // category: "Hospital News",
      image: "/pBvBCGngd50?si=3S3dyEK8kVdaQ6uQ",
      slug: "new-pediatric-wing-opening",
    },
  ]

  return (
  <section className="py-8 md:py-16 px-0 md:px-4  bg-apple-gray-50">
    <div className="container mx-auto max-w-6xl">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-2">Latest News & Updates</h2>
        <p className="text-apple-gray-400 max-w-2xl mx-auto">
          Stay updated with the latest news, health tips, and developments from MAMS Hospitals.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {newsItems.map((item) => (
          <div
            key={item.id}
            className="overflow-hidden border border-apple-gray-100 hover:border-apple-teal transition-all duration-300 rounded-3xl h-full flex flex-col bg-white"
          >
            <div className="aspect-[16/9] relative bg-apple-gray-50">
              {/* Conditional rendering for image or video */}
          
                <iframe
                  width="100%"
                  height="100%"
                  src={`https://www.youtube.com/embed/${item.image.split('?')[0]}`}
                  title={item.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              

              <div className="absolute top-4 left-4">
                <span className="text-xs font-medium backdrop-blur-sm text-apple-teal px-3 py-1 rounded-full">
                  {item.category}
                </span>
              </div>
            </div>
            <div className="p-6 flex flex-col flex-grow">
              <div className="flex items-center gap-2 mb-3 text-apple-gray-300 text-xs">
                <Calendar className="h-3 w-3" />
                <span>{item.date}</span>
              </div>
              <h3 className="font-semibold text-xl mb-2 text-apple-gray-500">{item.title}</h3>
              <p className="text-apple-gray-400 text-sm mb-4 flex-grow">{item.excerpt}</p>
              {/* <Link
                to={`/blog/${item.slug}`}
                className="inline-flex items-center text-apple-teal font-medium text-sm hover:underline mt-auto"
              >
                Read more <ArrowRight className="ml-1 h-4 w-4" />
              </Link> */}
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link to="/news">
          <div className="apple-button-secondary">View All News</div>
        </Link>
      </div>
    </div>
  </section>

  )
}

export default NewsSection
